import React, { Fragment } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { Trans } from 'react-i18next';

// import community from './images/yhteisö.svg'
// import consents from './images/consents.png';
// import preferences from './images/preferences.png';
// import ReportFigure from './ReportFigure';
// import sensotrendLogo from '../images/sensotrend.svg';
import agpImage from './images/agpreport.png';
import dailyViewImage from './images/dailyview.png';
import futureImage from './images/future.png';
import './Homepage.css';

function AgpDescription({ t }) {
  return (
    <Fragment>
      <h3>{t('reports.agp.heading')}</h3>
      <p>{t('reports.agp.description')}</p>
      <p className="link"><Link to="/reports/agp">{t('reports.readMore')}</Link></p>
    </Fragment>
  );
}

function DailyViewDescription({ t }) {
  return (
    <Fragment>
      <h3>{t('reports.daily.heading')}</h3>
      <p>{t('reports.daily.description')}</p>
      <p className="link"><Link to="/reports/day">{t('reports.readMore')}</Link></p>
    </Fragment>
  );
}

function ComingSoonDescription({ t }) {
  return (
    <Fragment>
      <h3>{t('reports.coming.heading')}</h3>
      <p>{t('reports.coming.description')}</p>
    </Fragment>
  );
}

/*

function InsulinViewDescription({ t }) {
  return (
    <Fragment>
      <h3>{t('reports.insulin.heading')}</h3>
      <p>{t('reports.insulin.description')}</p>
      <p className="link">{t('reports.readMore')}</p>
    </Fragment>
  );
}

function NutritionViewDescription({ t }) {
  return (
    <Fragment>
      <h3>{t('reports.nutrition.heading')}</h3>
      <p>{t('reports.nutrition.description')}</p>
      <p className="link">{t('reports.readMore')}</p>
    </Fragment>
  );
}

function ExerciseViewDescription({ t }) {
  return (
    <Fragment>
      <h3>{t('reports.exercise.heading')}</h3>
      <p>{t('reports.exercise.description')}</p>
      <p className="link">{t('reports.readMore')}</p>
    </Fragment>
  );
}

function SleepViewDescription({ t }) {
  return (
    <Fragment>
      <h3>{t('reports.sleep.heading')}</h3>
      <p>{t('reports.sleep.description')}</p>
      <p className="link">{t('reports.readMore')}</p>
    </Fragment>
  );
}
*/

function Homepage({ t }) {
  document.title = t('title');
  return (
    <article id="homepage">
      <h1>{t('All Your Diabetes Data in One Place')}</h1>
      <p>
        <Trans ns="homepage">
          <strong>Sensotrend Dashboard</strong> enriches glucose graphs with data on insulin dosing, nutrition, and physical activity.
        </Trans>
      </p>
      <p>{t('description')}
      </p>
      <h2>{t('reports.essentialHeading')}</h2>
      <figure id="AmbulatoryGlucoseProfile" className="sample-report">
        <img src={agpImage} alt={t('alt-AGP')} />
        <figcaption><AgpDescription t={t} /></figcaption>
      </figure>
      <figure id="DayView" className="sample-report">
        <img src={dailyViewImage} alt={t('alt-daily')} />
        <figcaption><DailyViewDescription t={t} /></figcaption>
      </figure>
      <figure id="ComingSoon" className="sample-report">
        <img src={futureImage} alt={t('alt-future')} />
        <figcaption><ComingSoonDescription t={t} /></figcaption>
      </figure>
    </article>
  );
}

export default Homepage;